import { Observable } from "rxjs/Observable"

import {
    dashboardBaseUrl,
    getURLSearchParams,
    getAuthHeader,
    postJSONConfig,
} from "./network-config"

export function getList(
    entityType,
    parameters,
    token,
    baseUrl = dashboardBaseUrl
) {
    const headers = getAuthHeader(token)
    const urlParameters = getURLSearchParams(parameters)
    let urlParamString = urlParameters.toString()
    if (urlParamString) {
        urlParamString = `?${urlParamString}`
    }
    return Observable.ajax.getJSON(
        `${baseUrl}/${entityType}${urlParamString}`,
        headers
    )
}

export function getListCount(
    entityType,
    parameters,
    token,
    baseUrl = dashboardBaseUrl
) {
    return getList(entityType, parameters.set("count", true), token, baseUrl)
}

export function getItem(
    entityType,
    id,
    token,
    additionalParameters,
    baseUrl = dashboardBaseUrl
) {
    const headers = getAuthHeader(token)
    let itemUrl = `${baseUrl}/${entityType}/${id}`
    if (additionalParameters) {
        const urlParameters = getURLSearchParams(additionalParameters)
        itemUrl += `?${urlParameters.toString()}`
    }
    return Observable.ajax.getJSON(itemUrl, headers)
}

export function putItem(
    entityType,
    id,
    entity,
    token,
    baseUrl = dashboardBaseUrl
) {
    const { headers, body } = postJSONConfig(entity, token)

    let url = `${baseUrl}/${entityType}`

    if (id) {
        url += `/${id}`
    }

    return Observable.ajax.put(url, body, headers).map((xhr) => xhr.response)
}

export function patchItem(
    entityType,
    id,
    entity,
    token,
    baseUrl = dashboardBaseUrl
) {
    const { headers, body } = postJSONConfig(entity, token)

    return Observable.ajax
        .patch(`${baseUrl}/${entityType}/${id}`, body, headers)
        .map((xhr) => xhr.response)
}

export function postItem(
    entityType,
    entity,
    token,
    baseUrl = dashboardBaseUrl
) {
    const { headers, body } = postJSONConfig(entity, token)
    return Observable.ajax
        .post(`${baseUrl}/${entityType}`, body, headers)
        .map((xhr) => xhr.response)
}

export function deleteItem(entityType, id, token, baseUrl = dashboardBaseUrl) {
    const headers = getAuthHeader(token)
    return Observable.ajax
        .delete(`${baseUrl}/${entityType}/${id}`, headers)
        .map((xhr) => xhr.response)
}
